import { useState } from "react";
import { ShieldCheck } from "lucide-react";

export default function FinanceUnlockModal({ onClose, onSubmit }) {
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!pwd) return;
    setBusy(true);
    await onSubmit(pwd);
    setBusy(false);
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <form onSubmit={submit} className="bg-white w-full max-w-sm rounded-lg shadow-2xl">
        <div className="px-5 py-4 border-b border-black/10">
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#ff5722] font-bold flex items-center gap-2">
            <ShieldCheck className="h-4 w-4" /> Finance section
          </div>
          <div className="font-bold text-[#0a0a0a] mt-1">Enter your finance password</div>
          <p className="text-xs text-[#4a4a4a] mt-1">A separate password protects payments &amp; invoices. Ask your account manager if you don&apos;t have it.</p>
        </div>
        <div className="px-5 py-4">
          <input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} autoFocus placeholder="••••••••"
            data-testid="client-finance-unlock-input"
            className="w-full font-mono border border-black/15 rounded px-3 py-2.5 text-sm outline-none focus:border-[#ff5722] focus:ring-2 focus:ring-[#ff5722]/20" />
        </div>
        <div className="px-5 py-4 border-t border-black/10 flex items-center justify-end gap-2">
          <button type="button" onClick={onClose} className="px-4 py-2 text-xs border border-black/15 rounded-full">Cancel</button>
          <button type="submit" disabled={busy} data-testid="client-finance-unlock-submit"
            className="inline-flex items-center gap-2 px-4 py-2 text-xs font-bold uppercase tracking-[0.15em] bg-[#0a0a0a] text-white rounded-full hover:bg-[#ff5722] disabled:opacity-60">
            <ShieldCheck className="h-4 w-4" /> {busy ? "Unlocking…" : "Unlock"}
          </button>
        </div>
      </form>
    </div>
  );
}
